import CallMergeIcon from '@mui/icons-material/CallMerge'
import { Stack } from '@mui/material'
import Typography from '@mui/material/Typography'
import { ConsoleDialog } from '@/components/ConsoleDialog'
import { MUI_STANDARD_TRANSITION_DURATION } from '@/constants/mui'
import { useUnmountingDelay } from '@/hooks/useUnmountingDelay'
import { STANDARIZED_GOLF_PLAYERS_TABLE_COLUMNS } from '@/views/DataAdmin/standarizedGolfPlayer.table'
import { StandarizedGolfPlayer } from '@/views/DataAdmin/types'

import { TableBase } from '../../base'
import { ActionMenuItem } from '../ActionMenuItem/ActionMenuItem'
import { useActionMenuContext } from '../context/ActionMenuContext'
import { MenuItemLike, WithSnackbarMessages } from '../index.types'

type Props<Data extends Record<string, unknown>> = MenuItemLike & {
  mergeResultPlayer: StandarizedGolfPlayer
  onClick: (row: Data) => Promise<void> | void
  isClickable?: (row: Data) => boolean
  disabled?: boolean
  confirmationMessage?: string
} & WithSnackbarMessages<Data>

export const ActionMergeQuarantineConfirm = <Data extends Record<string, unknown>>({
  mergeResultPlayer,
  displaySeparately,
  onClick,
  isClickable,
  disabled,
  confirmationMessage
}: Props<Data>) => {
  const {
    isOpen: dialogOpen,
    isMounted,
    open,
    close
  } = useUnmountingDelay(false, MUI_STANDARD_TRANSITION_DURATION)

  const { row, closeMenu } = useActionMenuContext<Data>()

  if (isClickable && isClickable(row) === false) return null

  const handleDialogClose = () => {
    close()
    closeMenu?.()
  }

  return (
    <>
      <ActionMenuItem
        disabled={disabled}
        text="Merge"
        icon={<CallMergeIcon />}
        onClick={open}
        displaySeparately={displaySeparately}
      />
      {isMounted && (
        <ConsoleDialog
          dialogSize={false}
          width={1100}
          open={dialogOpen}
          onClose={handleDialogClose}
          title="Merge player"
          SaveButtonProps={{
            text: 'Confirm',
            onClick: () => onClick?.(row)
          }}
          CloseButtonProps={{
            text: 'Cancel'
          }}
        >
          <Typography>{confirmationMessage}</Typography>
          <Typography>Merge result:</Typography>
          <Stack justifyContent="center" alignItems="center" mt={2} gap={2}>
            <TableBase
              dense
              data={[mergeResultPlayer]}
              columns={STANDARIZED_GOLF_PLAYERS_TABLE_COLUMNS}
              disablePagination
              disableColumnVisibility
            />
          </Stack>
        </ConsoleDialog>
      )}
    </>
  )
}
